import { object, string, array, number, SchemaOf, mixed } from 'yup';

import { DockerRBACFormValues, UnifiedAccess } from './types';

export const dockerRBACValidationSchema: SchemaOf<DockerRBACFormValues> =
  object({
    name: string()
      .required('Policy name is required')
      .trim()
      .min(1, 'Policy name is required'),
    environmentGroupIds: array(number().required()),
    accessList: array(
      object({
        Id: number().required(),
        Type: mixed<UnifiedAccess['Type']>().required(),
        Name: string().required(),
        Role: object({
          Id: number().required(),
          Name: string().required(),
        }).required(),
      })
    )
      .required('At least one user or team access is required')
      .min(1, 'At least one user or team access is required'),
  });
